import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RequireAuthProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children, requireAuth = true }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!requireAuth) {
    return <>{children}</>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
